import { KngItemCardDataState } from './definitions';

export class KngItemCardFactory
{
	public static buildState(): KngItemCardDataState
	{
		return {
			cssClass: '',
			cardType: 'unitCard',
			title: {
				label: ''
			},
			image: {
				label: '',
				url: '',
				alt: ''
			},
			error: '',
			loading: true,
			unit: [
				{
					label: '',
					description: {
						label: ''
					},
					details:
          [
          	{
          		header: '',
          		label: '',
          		description: {
          			label: ''
          		}
          	},
          	{
          		header: '',
          		label: '',
          		description: {
          			label: ''
          		}
          	}
          ]
				}
			],
			viewMoreButton: '',
			deviation: ''
		};
	}
}

